import { render, staticRenderFns } from "./dashboardGrupos.vue?vue&type=template&id=78824f6b&scoped=true&"
import script from "./dashboardGrupos.vue?vue&type=script&lang=js&"
export * from "./dashboardGrupos.vue?vue&type=script&lang=js&"
import style0 from "./dashboardGrupos.vue?vue&type=style&index=0&id=78824f6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78824f6b",
  null
  
)

export default component.exports